import httpClient from "utils/httpClientPayment";

// const path = "/payment";
const path = "/api";


export const sendBaoKim = (data) =>
  httpClient.post(`${path}/bao-kim/send`, data);

export const sendVNPay = (params) => httpClient.get(`${path}/vnpay/send`, { params });

export const sendZaloPay = (params) =>
  httpClient.get(`${path}/zalo-pay/send`, { params });

export const sendPayoo = (params) =>
  httpClient.get(`${path}/payoo/send`, { params });

export const generateVietQr = (params) =>
  httpClient.get(`${path}/vietqr/generate-qr`, { params });

export const sendOnePay = (params) =>
  httpClient.get(`${path}/onepay/send`, { params });
